import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useCallback, useMemo, useState } from 'react';
import { useDeviceType } from '../../../../responsive';
import { calculateScrollDistance, getTotalScrollDistance } from '../utils';
/** Хук реализует всю логику над кнопками скролящегося контейнера элементов */
export const useCarouselButtons = _ref => {
  let {
    scrollableContainerRef,
    itemsRef
  } = _ref;
  const deviceType = useDeviceType();
  const [buttonsVisibilityState, setButtonsVisibilityState] = useState({
    showLeftCarouselButton: false,
    showRightCarouselButton: false
  });
  const calculateButtonsVisibility = useCallback(() => {
    const scrollableContainer = scrollableContainerRef.current;
    if (!scrollableContainer) {
      return;
    }
    setButtonsVisibilityState({
      showLeftCarouselButton: scrollableContainer.scrollLeft > 0,
      showRightCarouselButton: scrollableContainer.scrollWidth > Math.round(scrollableContainer.clientWidth + scrollableContainer.scrollLeft)
    });
  }, [scrollableContainerRef]);
  useIsomorphicLayoutEffect(() => {
    const scrollableContainer = scrollableContainerRef.current;
    if (!scrollableContainer) {
      return;
    }
    calculateButtonsVisibility();

    // При ресайзе пересчитываем возможность отображение кнопок
    window.addEventListener('resize', calculateButtonsVisibility);

    // При скролле вычисляем, какие кнопки показывать
    scrollableContainer.addEventListener('scroll', calculateButtonsVisibility);
    return () => {
      window.removeEventListener('resize', calculateButtonsVisibility);
      scrollableContainer.removeEventListener('scroll', calculateButtonsVisibility);
    };
  }, [scrollableContainerRef, deviceType, calculateButtonsVisibility]);
  const handleLeftChevronClick = useCallback(() => {
    const scrollableContainer = scrollableContainerRef.current;
    const itemsContainer = itemsRef.current;
    const items = Array.from(itemsContainer.children).slice().reverse();
    const scrollDistance = calculateScrollDistance({
      items,
      container: scrollableContainer,
      direction: 'left'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'left'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, itemsRef]);
  const handleRightChevronClick = useCallback(() => {
    const scrollableContainer = scrollableContainerRef.current;
    const itemsContainer = itemsRef.current;
    const items = Array.from(itemsContainer.children);
    const scrollDistance = calculateScrollDistance({
      items,
      container: scrollableContainer,
      direction: 'right'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'right'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, itemsRef]);
  return useMemo(() => _objectSpread(_objectSpread({}, buttonsVisibilityState), {}, {
    onLeftCarouselButtonClick: handleLeftChevronClick,
    onRightCarouselButtonClick: handleRightChevronClick
  }), [buttonsVisibilityState, handleLeftChevronClick, handleRightChevronClick]);
};